import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import * as TanstackQuery from "./integrations/tanstack-query/root-provider";
import { routeTree } from "./routeTree.gen";
import { APP_MENU_ACTIVE_VALUE, APP_MENU_KEY } from "./hooks/use-app-menu";

export const getRouter = () => {
  const rqContext = TanstackQuery.getContext();

  const router = createRouter({
    routeTree,
    context: { ...rqContext },
    //defaultPreload: false,
    defaultViewTransition: {
      types({ fromLocation, toLocation }) {
        const isAppMenuOpened =
          (fromLocation?.search as Record<string, string>)?.[APP_MENU_KEY] ===
          APP_MENU_ACTIVE_VALUE;

        if (
          fromLocation?.pathname === toLocation?.pathname ||
          isAppMenuOpened
        ) {
          return false;
        }
        return ["fade"];
      },
    },
    scrollRestoration: true,
    getScrollRestorationKey: (location) => location.pathname,
    Wrap: (props: { children: React.ReactNode }) => {
      return (
        <TanstackQuery.Provider {...rqContext}>
          {props.children}
        </TanstackQuery.Provider>
      );
    },
  });

  setupRouterSsrQueryIntegration({
    router,
    queryClient: rqContext.queryClient,
  });

  return router;
};
